import { ComponentRegistry } from '../core/component-registry';
import { WorkSlipViewComponent } from './workslip-view/workslip-view.component';
import { WorkSlipListComponent } from './workslip-list/workslip-list.component';
import { WorkSlipDetailComponent } from './workslip-detail/workslip-detail.component';
var WorkSlipsModule = /** @class */ (function () {
    /**
     * Creates an instance of WorkSlipsModule.
     */
    function WorkSlipsModule() {
        ComponentRegistry.register('list', 'WorkSlipListComponent', WorkSlipListComponent);
        ComponentRegistry.register('overlay', 'WorkSlipViewComponent', WorkSlipViewComponent);
        ComponentRegistry.register('route', 'WorkSlipViewComponent', WorkSlipViewComponent);
        ComponentRegistry.register('route', 'WorkSlipDetailComponent', WorkSlipDetailComponent);
    }
    return WorkSlipsModule;
}());
export { WorkSlipsModule };
